import { useEffect, useState } from "react"
import { fetchQuery, graphql } from "relay-runtime"
import { useChFollowUpSickLeaveQuery as useChFollowUpSickLeaveQueryType } from "@/modules/patients/detail/sick-leave-certificate/ch/services/__generated__/useChFollowUpSickLeaveQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const chFollowUpSickLeaveQuery = graphql`
  query useChFollowUpSickLeaveQuery($progressNoteIds: [ID!]!, $sickLeaveId: ID) {
    ch_sickLeavesForFollowUp(progressNoteIds: $progressNoteIds, sickLeaveId: $sickLeaveId) {
      ... on SuccessSickLeavesForFollowUpResult {
        isSuccess
        result {
          id
          from
          to
          employerName
        }
      }
    }
  }
`

export type SickLeavesForFollowUpResult =
  useChFollowUpSickLeaveQueryType["response"]["ch_sickLeavesForFollowUp"]["result"]

export function useChFollowUpSickLeaveQuery(progressNoteIds: string[], sickLeaveId: string | null) {
  const [followUpResult, setFollowUpResult] = useState<SickLeavesForFollowUpResult>()

  useEffect(() => {
    fetchQuery<useChFollowUpSickLeaveQueryType>(
      RelayEnvironment,
      chFollowUpSickLeaveQuery,
      { progressNoteIds, sickLeaveId },
      { fetchPolicy: "network-only" },
    ).subscribe({
      next(data) {
        setFollowUpResult(data.ch_sickLeavesForFollowUp.isSuccess ? data.ch_sickLeavesForFollowUp.result : [])
      },
    })
  }, [progressNoteIds, sickLeaveId])

  return followUpResult
}
